import React from 'react';
import {Avatar, Box, Stack, SvgIcon, Typography, useMediaQuery} from "@mui/material";

function StackStatPresenter({icon, value, label, backgroundColor}) {
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    return (
      <Stack

          sx={{
              padding: "15px",
              backgroundColor: backgroundColor,
              borderRadius: 2.5,
          }}
          alignItems="center"
          direction={ 'column' }
      >
          <div style={{marginRight: "15px"}}>
              <Avatar sx={{backgroundColor: "transparent"}}>
                  <SvgIcon style={{fontSize: "35px"}}>
                      {icon}
                  </SvgIcon>
              </Avatar>
          </div>
          <Box sx={{ flexGrow: 1 }}>
              <Typography
                  sx={{textAlign: "center"}}
                  color="text.secondary"
                  variant="body2"
              >
                  {label}
              </Typography>
              <Typography
                  sx={{textAlign: "center"}}
                  color="text.primary"
                  variant="h4"
              >
                  {value}
              </Typography>
          </Box>
      </Stack>
  )
}

export default StackStatPresenter